const ACTIVE_STATUS = new Set([
  'active',
  'online',
  'available',
  'ready',
  'idle',
  'busy',
  'incall',
  'oncall',
  'connected',
  'ringing',
  'dialing',
  'registered',
  'inuse',
  'using',
  'hold',
  'onhold',
  'talking',
]);

const INACTIVE_STATUS = new Set([
  'inactive',
  'offline',
  'loggedout',
  'logout',
  'disabled',
  'unavailable',
  'notready',
  'dnd',
  'donotdisturb',
  'disconnected',
  'unregistered',
  'error',
  'break',
  'lunch',
  'training',
  'meeting',
  'away',
]);

const FLAG_KEYS = [
  'IsActive',
  'isActive',
  'Active',
  'active',
  'IsLoggedIn',
  'isLoggedIn',
  'LoggedIn',
  'loggedIn',
  'IsLogin',
  'isLogin',
  'LoginStatus',
  'loginStatus',
  'IsOnline',
  'isOnline',
  'Online',
  'online',
  'IsAvailable',
  'isAvailable',
  'Available',
  'available',
];

const STATUS_KEYS = [
  'status',
  'Status',
  'AgentStatus',
  'agentStatus',
  'State',
  'state',
  'Presence',
  'presence',
  'Availability',
  'availability',
  'LoginState',
  'loginState',
];

const normalizeToken = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');

const normalizeBool = (value) => {
  if (value === true || value === false) return value;
  if (value === 1) return true;
  if (value === 0) return false;
  const token = normalizeToken(value);
  if (!token) return null;
  if (['1', 'true', 'yes', 'y', 'on'].includes(token)) return true;
  if (['0', 'false', 'no', 'n', 'off'].includes(token)) return false;
  return null;
};

const flagFromAgent = (agent) => {
  if (!agent) return null;
  for (const key of FLAG_KEYS) {
    if (Object.prototype.hasOwnProperty.call(agent, key)) {
      const flag = normalizeBool(agent[key]);
      if (flag !== null) return flag;
    }
  }
  return null;
};

const statusFromAgent = (agent) => {
  if (!agent) return null;
  for (const key of STATUS_KEYS) {
    const token = normalizeToken(agent[key]);
    if (!token) continue;
    if (ACTIVE_STATUS.has(token)) return true;
    if (INACTIVE_STATUS.has(token)) return false;
  }
  return null;
};

const isAgentActive = (agent) => {
  const flag = flagFromAgent(agent);
  if (flag !== null) return flag;
  const status = statusFromAgent(agent);
  if (status !== null) return status;
  return null;
};

export const filterActiveAgents = (agents = []) => {
  const list = Array.isArray(agents) ? agents : [];
  const hasSignal = list.some((agent) => isAgentActive(agent) !== null);
  if (!hasSignal) return list;
  const filtered = list.filter((agent) => isAgentActive(agent) === true);
  return filtered.length ? filtered : list;
};
